import { useDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import type { Middleware } from 'redux';
import { combineReducers } from 'redux';

import { apiReducer, baseApi } from '@klp/core/api';
import { appDispatch, appReducer } from '@klp/core/app';

const errorMiddleware: Middleware = (store) => (next) => (action) => {
    const { dispatchErrorOccured } = appDispatch(store.dispatch);
    try {
        return next(action);
    } catch (error) {
        dispatchErrorOccured(error);
    }
};

export const reducers = combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    customApi: apiReducer,
    app: appReducer,
});

const middleware = [baseApi.middleware, errorMiddleware];

const initStore = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(middleware),
});

export type AppDispatch = typeof initStore.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export const Store = initStore;
